module.exports = __webpack_public_path__ + "static/media/pic2.75fc1f06.jpg";